import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgGuestFeedbackSyncsSidebarQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrgGuestFeedbackSyncsSidebarQuery = { __typename?: 'Query', OrgGuestFeedbackSyncs: { __typename?: 'OrgGuestFeedbackSyncs', objects: Array<{ __typename?: 'OrgGuestFeedbackSync', id: string, startedAt: string, completedAt?: string | null, feedbacks: Array<{ __typename?: 'GuestFeedback', id: string, text?: string | null, rating?: number | null, date: string, integrationLocation?: { __typename?: 'GuestFeedbackIntegrationLocation', id: string, sourceName?: string | null } | null, csvUploadLocation?: { __typename?: 'GuestFeedbackCsvUploadLocation', id: string, locationName: string } | null }>, orgGuestFeedbackIntegration: { __typename?: 'OrgGuestFeedbackIntegration', id: string, googleBusinessConfig?: { __typename?: 'OrgGuestFeedbackGoogleBusinessConfig', id: string } | null, ovationIntegrationConfig?: { __typename?: 'OrgGuestFeedbackOvationIntegrationConfig', id: string } | null, tattleIntegrationConfig?: { __typename?: 'OrgGuestFeedbackTattleIntegrationConfig', id: string } | null } }> } };


export const OrgGuestFeedbackSyncsSidebarDocument = gql`
    query OrgGuestFeedbackSyncsSidebar {
  OrgGuestFeedbackSyncs {
    objects {
      id
      startedAt
      completedAt
      feedbacks {
        id
        text
        rating
        date
        integrationLocation {
          id
          sourceName
        }
        csvUploadLocation {
          id
          locationName
        }
      }
      orgGuestFeedbackIntegration {
        id
        googleBusinessConfig {
          id
        }
        ovationIntegrationConfig {
          id
        }
        tattleIntegrationConfig {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useOrgGuestFeedbackSyncsSidebarQuery__
 *
 * To run a query within a React component, call `useOrgGuestFeedbackSyncsSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGuestFeedbackSyncsSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGuestFeedbackSyncsSidebarQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgGuestFeedbackSyncsSidebarQuery(baseOptions?: Apollo.QueryHookOptions<OrgGuestFeedbackSyncsSidebarQuery, OrgGuestFeedbackSyncsSidebarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGuestFeedbackSyncsSidebarQuery, OrgGuestFeedbackSyncsSidebarQueryVariables>(OrgGuestFeedbackSyncsSidebarDocument, options);
      }
export function useOrgGuestFeedbackSyncsSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGuestFeedbackSyncsSidebarQuery, OrgGuestFeedbackSyncsSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGuestFeedbackSyncsSidebarQuery, OrgGuestFeedbackSyncsSidebarQueryVariables>(OrgGuestFeedbackSyncsSidebarDocument, options);
        }
export type OrgGuestFeedbackSyncsSidebarQueryHookResult = ReturnType<typeof useOrgGuestFeedbackSyncsSidebarQuery>;
export type OrgGuestFeedbackSyncsSidebarLazyQueryHookResult = ReturnType<typeof useOrgGuestFeedbackSyncsSidebarLazyQuery>;
export type OrgGuestFeedbackSyncsSidebarQueryResult = Apollo.QueryResult<OrgGuestFeedbackSyncsSidebarQuery, OrgGuestFeedbackSyncsSidebarQueryVariables>;